import styled, { css } from 'styled-components';
import { BadgeProps } from './types';

export const StyledBadge = styled.span<Pick<BadgeProps, 'variant' | 'size'>>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-weight: 600;
  white-space: nowrap;

  ${({ size }) =>
    size === 'small'
      ? css`
          padding: 2px 8px;
          font-size: 11px;
        `
      : css`
          padding: 4px 12px;
          font-size: 12px;
        `}

  ${({ variant, theme }) => {
    switch (variant) {
      case 'internal':
      case 'utility-internal':
        return css`
          background-color: ${theme.colors.greenTransparent ||
          'rgba(0, 128, 21, 0.1)'};
          color: ${theme.colors.green || '#008015'};
          border: 1px solid ${theme.colors.green || '#008015'};
        `;

      case 'external':
      case 'utility-external':
        return css`
          background-color: ${theme.colors.orangeTransparent ||
          'rgba(239, 125, 5, 0.1)'};
          color: ${theme.colors.secondaryOrange || '#EF7D05'};
          border: 1px solid ${theme.colors.secondaryOrange || '#EF7D05'};
        `;

      case 'accident':
        return css`
          background-color: rgba(220, 53, 69, 0.1);
          color: #dc3545;
          border: 1px solid #dc3545;
        `;

      default:
        return css`
          background-color: ${theme.colors.greenTransparent ||
          'rgba(0, 128, 21, 0.1)'};
          color: ${theme.colors.green || '#008015'};
          border: 1px solid ${theme.colors.green || '#008015'};
        `;
    }
  }}
`;
